import { render, staticRenderFns } from "./IntroductionAndFeatures.vue?vue&type=template&id=4d7e2ac8&"
import script from "./IntroductionAndFeatures.vue?vue&type=script&lang=js&"
export * from "./IntroductionAndFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports